<div tid="note_detail_note_body" class="container" [ngClass]="{'note-detail-render-done':renderDone}">
    <div [innerHTML]="hightLightedBody | safeHtml" (click)="previewImg($event)"></div>
</div>